import { render, staticRenderFns } from "./CardIndicacaoPcd.vue?vue&type=template&id=47d985df&scoped=true&"
import script from "./CardIndicacaoPcd.vue?vue&type=script&lang=js&"
export * from "./CardIndicacaoPcd.vue?vue&type=script&lang=js&"
import style0 from "./CardIndicacaoPcd.vue?vue&type=style&index=0&id=47d985df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d985df",
  null
  
)

export default component.exports